import * as React from 'react';

import { ERefsApps } from '@enums';

import { IAppsStore } from '@stores';

import { AppsCarousel, ContentPanel, EAppItemType } from '@components';

import { MAX_APPS_FOR_SHOW_MORE } from '../utils/constants';

import * as s from './style/Panel.scss';

interface IPanel {
	title: string;
	linkUrl: string;
	type?: EAppItemType;
	refUrl: ERefsApps;
	store: IAppsStore;
	isVisible?: boolean;
	onLinkClick?(): void;
	hasTitle?: boolean;
	hasDescription?: boolean;
	hasInstalls?: boolean;
}

export const AppsPanel = ({
	title,
	linkUrl,
	store,
	onLinkClick,
	isVisible = true,
	refUrl,
	type = EAppItemType.MEDIUM,
	hasTitle = true,
	hasDescription = false,
	hasInstalls = false,
}: IPanel) => {
	const apps = 'data' in store ? store.data?.apps : [];
	const status = 'status' in store ? store.status : null;

	if (!isVisible) {
		return null;
	}

	return <ContentPanel
		title={title}
		onLinkClick={onLinkClick}
		linkUrl={ apps?.length >= MAX_APPS_FOR_SHOW_MORE ? linkUrl : ''}
	>
		<AppsCarousel
			className={s.carousel}
			apps={apps}
			responseStatus={status}
			type={type}
			urlRef={refUrl}
			hasTitle={hasTitle}
			hasDescription={hasDescription}
			hasInstalls={hasInstalls}
		/>
	</ContentPanel>;
};
